import React, { Component } from 'react';

class SinglePortfolio extends Component {
    render() {
        return (
            <div className="col-sm-6 col-lg-4 mt-4 pt-1">
                <div style={{background:'#1d293a'}} className="portfolio-box p-3 rounded text-white">
                <h4>{this.props.projectName}</h4>
                    <p className="text-white my-3 mb-4">{this.props.projectDescription}</p>
                    <p className='mt-3'><b>ক্যাটাগরি :</b> {this.props.cat}</p>
                    <div className="my-3">
                    <a href={this.props.projectCode} target='_blank'><i className="fa fa-github text-white"></i></a>
                    <a href={this.props.projectLink} target='_blank'><i className="fa fa-external-link text-white mx-3"></i></a>
                    </div>
                    <div className="tool-used">
                    {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default SinglePortfolio;